import styled from "styled-components";

import theme from "../../theme";

const Subtitle = styled.div`
  display: flex;
  margin-top: 0;
  margin-bottom: 0;
  color: ${theme.colors.black};
  font-family: ${theme.fonts.regular};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.7pt;
  align-self: center;
  align-items: center;
  text-align: center;
`;

export default Subtitle;
